import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover [data-overlay] {
    opacity: 1;
  }
`;

export default Wrapper;
